import { useCallback, useEffect, useState } from 'react';
import { usePortalCmsRefresh } from '../../context/RealtimeSyncContext';

const API = process.env.REACT_APP_API_BASE_URL;

const DOCUMENTS_PORTAL_SLUGS = ['portal-documents-page', 'portal-documents-help', 'documents'];

export const useDocumentsPortal = () => {
  const [page, setPage] = useState(null);
  const [helpSection, setHelpSection] = useState(null);
  const [loading, setLoading] = useState(true);

  const load = useCallback(async () => {
    setLoading(true);
    try {
      const [pageRes, helpRes] = await Promise.all([
        fetch(`${API}/api/portal-cms/page/portal-documents-page`),
        fetch(`${API}/api/portal-cms/page/portal-documents-help`),
      ]);
      const pageData = pageRes.ok ? (await pageRes.json()).data : null;
      const helpData = helpRes.ok ? (await helpRes.json()).data : null;
      setPage(pageData);
      setHelpSection(helpData);
    } catch {
      setPage(null);
      setHelpSection(null);
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    load();
  }, [load]);

  usePortalCmsRefresh(DOCUMENTS_PORTAL_SLUGS, load);

  return { page, helpSection, loading, refresh: load };
};
